import server from '@/utils/request';
import { BASE_API_PATH } from '@/utils/variable';
// Save
export const save_api = (data: any) => server.post(`/system/config/scope/_save`, data)
// Get details
export const getDetails_api = (data: any) => server.post<any>(`/system/config/scopes`, data)

export const APP_INSTALLER_UPLOAD = `${BASE_API_PATH}/static/file/upload`;
